<template>
  <div id="employerReport">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container>
      <v-form>
        <v-layout class="mt-4">
          <v-flex xs6 sm12>
            <h4 class="filter text-sm-left">
              <i class="material-icons">filter_list</i> Filtrar por
            </h4>
          </v-flex>
          <v-flex xs6 sm12>
            <v-select
              :items="filters"
              item-text="label"
              item-value="value"
              v-model="filterSelected"
              @change="showFilter()"
            ></v-select>
          </v-flex>
        </v-layout>
        <v-layout v-if="!showDateFilter">
          <v-flex>
            <v-select :items="selectItems" item-text="name" item-value="id"></v-select>
          </v-flex>
        </v-layout>
        <v-layout v-if="showDateFilter">
          <v-flex xs12 sm6>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="startDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="startDate"
                  :label="$t('employerReports.startDate')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="startDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menu.save(startDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm6>
            <v-menu
              ref="menu"
              v-model="menu"
              :close-on-content-click="false"
              :nudge-right="40"
              :return-value.sync="endDate"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="endDate"
                  :label="$t('employerReports.endDate')"
                  prepend-icon="event"
                  readonly
                  v-on="on"
                ></v-text-field>
              </template>
              <v-date-picker v-model="endDate" no-title scrollable>
                <v-spacer></v-spacer>
                <v-btn flat color="primary" @click="menu = false">Cancel</v-btn>
                <v-btn flat color="primary" @click="$refs.menu.save(endDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-flex>
        </v-layout>
        <v-layout>
          <v-flex>
            <v-btn color="primary" @click="search()">{{$t('general.search')}}</v-btn>
          </v-flex>
        </v-layout>
      </v-form>
      <template v-if="showResult">
        <v-layout v-for="expEmpl in employerExpenses" :key="expEmpl.id" class="mt-2">
          <v-flex>
            <h2 class="text-sm-left mb-2">{{expEmpl.user.name}}</h2>
            <v-data-table
              :headers="headers"
              :items="expEmpl.expenses"
              :totalEmployer="totalEmployer(expEmpl)"
              class="elevation-2"
            >
              <template v-slot:headers="props">
                <tr class="primary">
                  <th
                    v-for="header in props.headers"
                    :class="['font-weight-black white--text column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                    :key="header.text"
                  >
                    <h2>{{header.text}}</h2>
                  </th>
                </tr>
              </template>
              <template v-slot:items="props">
                <tr width="40px">
                  <td class="text-sm-center">{{props['item'].name}}</td>
                  <td class="text-sm-center">{{props['item'].subtotal}}</td>
                  <td class="text-sm-center">{{props['item'].discount}}</td>
                  <td class="text-sm-center">{{props['item'].iva}}</td>
                  <td class="text-sm-center">{{props['item'].total}}</td>
                  <td class="text-sm-center">{{props['item'].currency}}</td>
                </tr>
              </template>
              <template v-slot:footer>
                <tr>
                  <td class="text-sm-center strong">{{$t('general.totalExpenses')}}</td>
                  <td class="text-sm-center strong">$ {{allSubtotal(expEmpl)}}</td>
                  <td class="text-sm-center strong">$ {{allDiscount(expEmpl)}}</td>
                  <td class="text-sm-center strong">$ {{allIva(expEmpl)}}</td>
                  <td class="text-sm-center strong">$ {{allTotal(expEmpl)}}</td>
                  <td class="text-sm-center strong">$ {{currency(expEmpl)}}</td>
                </tr>
              </template>
            </v-data-table>
            <table></table>
            <br />
            <br />
          </v-flex>
        </v-layout>
        <h1>Gran gasto</h1>
        <v-layout>
          <v-flex>
            <v-data-table :headers="headers" hide-actions class="elevation-2" :items="granTotal()">
              <template v-slot:headers="props">
                <tr class="primary">
                  <th
                    class="font-weight-black white--text column"
                    v-for="(header, index) in props.headers"
                    :key="header.text"
                  >
                    <h2 v-if="index!=0">{{header.text}}</h2>
                  </th>
                </tr>
              </template>
              <template v-slot:footer>
                <tr>
                  <td></td>
                  <td>$6,242.23</td>
                  <td>$6,242.23</td>
                  <td>$6,242.23</td>
                  <td>$6,242.23</td>
                  <td>MXM</td>
                </tr>
              </template>
            </v-data-table>
          </v-flex>
        </v-layout>
      </template>
      <br />
      <br />
      <!--
                <v-data-table
                    :headers="headers"
                    :items="employerExpenses"
                    class="elevation-2"
                >
                    <template v-slot:headers="props">
                        <tr class="primary">
                            <th
                                v-for="header in props.headers"
                                :class="['font-weight-black white--text column', header.sortable ? 'sortable' : '', pagination.descending ? 'desc' : 'asc', header.value === pagination.sortBy ? 'active' : '']"
                                :key="header.text">
                                <h2>{{header.text}}</h2>
                            </th>
                        </tr>
                    </template>
                    <template v-slot:items="props">
                        <tr width="40px">
                            <td colspan="6" class="text-sm-left ">
                               <span class="strong">
                                   {{props['item'].user.name}}
                               </span>
                            </td>
                        </tr>
                        <tr v-for="exp in props['item'].expenses" :key="exp.id" class="text-sm-center">
                            <td class="text-sm-center">{{exp.name}}</td>
                            <td class="text-sm-center">{{exp.subtotal}}</td>
                            <td class="text-sm-center">{{exp.discount}}</td>
                            <td class="text-sm-center">{{exp.iva}}</td>
                            <td class="text-sm-center">{{exp.total}}</td>
                            <td class="text-sm-center">{{exp.currency}}</td>
                        </tr>
                        <tr>
                            <td class="text-sm-center"><span class="strong">10,923</span></td>
                            <td class="text-sm-center"><span class="strong">2,923</span></td>
                            <td class="text-sm-center"><span class="strong">130,923</span></td>
                            <td class="text-sm-center"><span class="strong">3,923</span></td>
                            <td class="text-sm-center"><span class="strong">1,923</span></td>
                            <td class="text-sm-center"><span class="strong">4,923</span></td>
                        </tr>
                    </template>
                </v-data-table>
      -->
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'employerReportComponent',
  data () {
    return {
      showResult: false,
      startDate: new Date().toISOString().substr(0, 10),
      endDate: new Date().toISOString().substr(0, 10),
      pagination: {
        descending: false,
        page: 0,
        rowsPerPage: 5, // -1 for All',
        totalItems: 0
      },
      filterSelected: 'date',
      showDateFilter: false,
      filterValues: ['date', 'area', 'office', 'branch', 'project'],
      menu: false,
      selectItems: [],
      projects: [
        {
          id: 1,
          name: 'Projecto 1'
        },
        {
          id: 2,
          name: 'Projecto 2'
        },
        {
          id: 3,
          name: 'Projecto 3'
        }
      ],
      areas: [
        {
          id: 1,
          name: 'Area 1'
        },
        {
          id: 2,
          name: 'Area 2'
        },
        {
          id: 3,
          name: 'Area 3'
        }
      ],
      offices: [
        {
          id: 1,
          name: 'Oficina 1'
        },
        {
          id: 2,
          name: 'Oficina 2'
        },
        {
          id: 3,
          name: 'Oficina 3'
        }
      ],
      branches: [
        {
          id: 1,
          name: 'Sucursal 1'
        },
        {
          id: 2,
          name: 'Sucursal 2'
        },
        {
          id: 3,
          name: 'Sucursal 3'
        }
      ],
      filters: this.$t('employerReports.filters'),
      employerExpenses: [
        {
          id: 1,
          user: {
            id: 0,
            name: 'Alejandra Torres'
          },
          expenses: [
            {
              id: 1,
              name: 'Combustibles y lubricatntes',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            },
            {
              id: 2,
              name: 'Viaticos - hotel',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            },
            {
              id: 3,
              name: 'Teléfono, internet',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            },
            {
              id: 4,
              name: 'Papeleria y articulos de oficina',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            }
          ]
        },
        {
          id: 2,
          user: {
            id: 0,
            name: 'Iván Calderon'
          },
          expenses: [
            {
              id: 5,
              name: 'Combustibles y lubricantes',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            },
            {
              id: 6,
              name: 'Viaticos ',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            },
            {
              id: 7,
              name: 'Teléfono, internet',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            },
            {
              id: 8,
              name: 'Papeleria y articulos de oficina',
              subtotal: 6538.86,
              discount: 0.0,
              iva: 1046,
              total: 7585.05,
              currency: 'MXM'
            }
          ]
        }
      ]
    }
  },
  computed: {
    heading () {
      return this.$t('employerReports.name')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'far fa-file-alt fa-fw icon-color'
    },
    headers () {
      return [
        {
          text: this.$t('general.expense'),
          align: 'center',
          value: 'expense',
          sortable: false
        },
        {
          text: this.$t('general.subtotal'),
          align: 'center',
          value: 'subtotal',
          sortable: false
        },
        {
          text: this.$t('general.iva'),
          align: 'center',
          value: 'iva',
          sortable: false
        },
        {
          text: this.$t('general.discount'),
          align: 'center',
          value: 'discount',
          sortable: false
        },
        {
          text: this.$t('general.total'),
          align: 'center',
          value: 'total',
          sortable: false
        },
        {
          text: this.$t('general.currency'),
          align: 'center',
          value: 'currency',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.showFilter()
  },
  methods: {
    granTotal () {
      return [
        { label: 'Subtotal', value: ' $21,073.32' },
        { label: 'Descuento', value: '$400.00' },
        { label: 'IVA', value: '$336.00' },
        { label: 'Total', value: '$2,379.71' },
        { label: 'Moneda', value: 'MXN' }
      ]
    },
    totalEmployer (val) {
      var total = {
        id: 1,
        name: 'Papeleria y articulos de oficina',
        subtotal: 6538.86,
        discount: 0.0,
        iva: 1046,
        total: 7585.05,
        currency: 'MXM'
      }
      return total
    },
    allDiscount (val) {
      return 9328943
    },
    allIva (val) {
      return 2344
    },
    allTotal (val) {
      return 13455
    },
    currency (val) {
      return val.expenses[0].currency
    },
    allSubtotal (val) {
      var total = 0
      val.expenses.forEach(v => {
        total += v.subtotal
      })
      return total
    },
    saveDate () {
      return this.date
    },
    search () {
      this.showResult = true
    },
    showFilter () {
      if (this.filterSelected === 'date') {
        this.showDateFilter = true
      } else {
        this.showDateFilter = false
      }
      if (this.filterSelected === 'area') {
        this.selectItems = this.areas
      }
      if (this.filterSelected === 'branch') {
        this.selectItems = this.branches
      }
      if (this.filterSelected === 'office') {
        this.selectItems = this.offices
      }
      if (this.filterSelected === 'project') {
        this.selectItems = this.projects
      }
    }
  }
}
</script>
<style >
.strong {
  font-weight: bold;
}
.red {
  color: red;
}
.filter {
  font-size: 1.2em;
  font-weight: bold;
  text-align: left;
}
</style>



// WEBPACK FOOTER //
// src/components/employerReport.component.vue